import React, { useState } from "react";
import { Container, Row, Tab, Tabs } from "react-bootstrap";
import Enter from "../enter/enter";
import Display from "../display/display";
const MainAjinda = ({ userData }) => {
  const [key, setKey] = useState("enter");
  const [Filee, setFilee] = useState([]);
  const [FileeBase64, setBase64] = useState("");
  const [showName, setshowName] = useState([]);
  const [Datee, setDatee] = useState("");
  const [Dategalasa, setDategalasa] = useState("");
  const [Namemowakell, setNamemowakell] = useState("");
  const [Sefamo, setSefamo] = useState("");
  const [NameKhesm, setNameKhesm] = useState([]);
  const [SefaKhesm, setSefaKhesm] = useState("");
  const [TypeDawa, setTypeDawa] = useState("");
  const [NumberDawa, setNumberDawa] = useState("");
  const [Year, setYear] = useState("");
  const [Mawdodawa, setMawdodawa] = useState("");
  const [TakadyDegree, setTakadyDegree] = useState("");
  const [Mahkamaa, setMahkama] = useState("");
  const [Numbercircle, setNumbercircle] = useState("");
  const [Typecircle, setTypecircle] = useState("");
  const [SummaryDawa, setSummaryDawa] = useState("");
  const [Nots, setNots] = useState("");
  const [NotsImg, setNotsImg] = useState("");
  const [Qarar, setQarar] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [Eye, setEye] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [AjendaID, setAjendaID] = useState("");

  return (
    <div className="main">
      <Container>
        <h4 className="text-center">إدارة الأجندة القضائية </h4>
        <Row>
          <div className="col-md-12">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="mb-3">
              <Tab eventKey="enter" title="بيانات الأجندة">
                <Enter
                  userData={userData}
                  setAjendaID={setAjendaID}
                  AjendaID={AjendaID}
                  setIsEdit={setIsEdit}
                  isEdit={isEdit}
                  setEye={setEye}
                  Eye={Eye}
                  key={key}
                  setKey={setKey}
                  Filee={Filee}
                  setFilee={setFilee}
                  FileeBase64={FileeBase64}
                  setBase64={setBase64}
                  showName={showName}
                  setshowName={setshowName}
                  Datee={Datee}
                  setDatee={setDatee}
                  Dategalasa={Dategalasa}
                  setDategalasa={setDategalasa}
                  Namemowakell={Namemowakell}
                  setNamemowakell={setNamemowakell}
                  Sefamo={Sefamo}
                  setSefamo={setSefamo}
                  NameKhesm={NameKhesm}
                  setNameKhesm={setNameKhesm}
                  SefaKhesm={SefaKhesm}
                  setSefaKhesm={setSefaKhesm}
                  TypeDawa={TypeDawa}
                  setTypeDawa={setTypeDawa}
                  NumberDawa={NumberDawa}
                  setNumberDawa={setNumberDawa}
                  Year={Year}
                  setYear={setYear}
                  Mawdodawa={Mawdodawa}
                  setMawdodawa={setMawdodawa}
                  TakadyDegree={TakadyDegree}
                  setTakadyDegree={setTakadyDegree}
                  Mahkamaa={Mahkamaa}
                  setMahkama={setMahkama}
                  Numbercircle={Numbercircle}
                  setNumbercircle={setNumbercircle}
                  Typecircle={Typecircle}
                  setTypecircle={setTypecircle}
                  SummaryDawa={SummaryDawa}
                  setSummaryDawa={setSummaryDawa}
                  Nots={Nots}
                  setNots={setNots}
                  NotsImg={NotsImg}
                  setNotsImg={setNotsImg}
                  Qarar={Qarar}
                  setQarar={setQarar}
                  selectedFile={selectedFile}
                  setSelectedFile={setSelectedFile}
                />
              </Tab>
              {/* <Tab eventKey="money" title="ماليات">
                <Money />
              </Tab> */}
              <Tab eventKey="display" title="عرض">
                <Display
                  setAjendaID={setAjendaID}
                  AjendaID={AjendaID}
                  setIsEdit={setIsEdit}
                  isEdit={isEdit}
                  setEye={setEye}
                  Eye={Eye}
                  key={key}
                  setKey={setKey}
                  Filee={Filee}
                  setFilee={setFilee}
                  FileeBase64={FileeBase64}
                  setBase64={setBase64}
                  showName={showName}
                  setshowName={setshowName}
                  Datee={Datee}
                  setDatee={setDatee}
                  Dategalasa={Dategalasa}
                  setDategalasa={setDategalasa}
                  Namemowakell={Namemowakell}
                  setNamemowakell={setNamemowakell}
                  Sefamo={Sefamo}
                  setSefamo={setSefamo}
                  NameKhesm={NameKhesm}
                  setNameKhesm={setNameKhesm}
                  SefaKhesm={SefaKhesm}
                  setSefaKhesm={setSefaKhesm}
                  TypeDawa={TypeDawa}
                  setTypeDawa={setTypeDawa}
                  NumberDawa={NumberDawa}
                  setNumberDawa={setNumberDawa}
                  Year={Year}
                  setYear={setYear}
                  Mawdodawa={Mawdodawa}
                  setMawdodawa={setMawdodawa}
                  TakadyDegree={TakadyDegree}
                  setTakadyDegree={setTakadyDegree}
                  Mahkamaa={Mahkamaa}
                  setMahkama={setMahkama}
                  Numbercircle={Numbercircle}
                  setNumbercircle={setNumbercircle}
                  Typecircle={Typecircle}
                  setTypecircle={setTypecircle}
                  SummaryDawa={SummaryDawa}
                  setSummaryDawa={setSummaryDawa}
                  Nots={Nots}
                  setNots={setNots}
                  NotsImg={NotsImg}
                  setNotsImg={setNotsImg}
                  Qarar={Qarar}
                  setQarar={setQarar}
                  selectedFile={selectedFile}
                  setSelectedFile={setSelectedFile}
                />
              </Tab>
            </Tabs>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default MainAjinda;
